"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const config_1 = require("config");
const ExternalLink_1 = __importDefault(require("../../../../components/ExternalLink"));
function WizardFooter() {
    return ((0, jsx_runtime_1.jsxs)("footer", { children: [(0, jsx_runtime_1.jsx)("div", { className: "footer-container", children: (0, jsx_runtime_1.jsx)(ExternalLink_1.default, { href: config_1.URL.PATIENT_SUPPORT, children: (0, jsx_runtime_1.jsx)("span", { children: "PATIENT SUPPORT" }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "copyright", children: ["Copyright @ ", new Date().getFullYear(), " Alphaeon Credit. All rights reserved."] })] }));
}
exports.default = (0, react_1.memo)(WizardFooter);
